import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { OptionModule } from '../../../options/abstract/option.module';
import { RegularCellComponent } from './regular-cell.component';

@NgModule({
  imports: [
    CommonModule,
    // OptionModule,
  ],
  declarations: [ RegularCellComponent ],
  exports:[RegularCellComponent]
})
export class RegularCellModule { }

